import React from "react"
import styled, { css } from "styled-components"
import Newsletter, { NewsletterProps } from "./newsletter.component"
import { SecondaryHeading, secondaryHeadingStyles } from "./heading.component"
import { MediumSection, SectionLayout } from "./sections/section.component"
import { AppFunctionComponent } from "../../types"

const heroArticleSpacings = css`
  padding-left: 20px;
  padding-right: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding-left: 30px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    padding-left: 50px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.desktopMedium}px) {
    padding-left: 100px;
  }
`

const NewsletterTitle = styled.div`
  padding-right: 60px;
  box-sizing: border-box;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    max-width: calc(100% - 610px);
    width: 40%;
  }

  ${SecondaryHeading} {
    margin-top: 0;
    margin-bottom: 0;

    @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
      margin-bottom: 8px;
    }
  }

  p {
    ${secondaryHeadingStyles};
    font-weight: 400;
  }
`

const NewsletterWrapper = styled(MediumSection)`
  --max-width: 1260;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  ${heroArticleSpacings};
  margin-top: calc(var(--grid-spacing) * -1);
  padding-top: 45px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    flex-direction: row;
    padding-right: 80px;
  }
`

const MiddleContentNewsletter: AppFunctionComponent<NewsletterProps> = ({
  children,
  ...props
}) => {
  return (
    <NewsletterWrapper layout={SectionLayout.Text}>
      <NewsletterTitle>{children}</NewsletterTitle>
      <Newsletter split={false} {...props} />
    </NewsletterWrapper>
  )
}

export default MiddleContentNewsletter
